/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-var: 0 */
/* globals _, JSWidget, JSWidgetList */

/***
 * This method returns related Toggles
 *
 * @return ToggleSide
 * @return Toggle
 * */
_.namespace(`mp.widgets`, function() {
  "use strict";

  var ToggleSide = function(div, value) {
    this.class_name = `toggle_side`;
  };
  _.inherit(ToggleSide, JSWidget);

  ToggleSide.prototype.create = function(div, value, config) {
    this.config = config;
    ToggleSide.superclass.create.call(this, div);
    this.container.attr(`val`, value[0]);
    this.value = value[0];
    this.container.html(value[1]);
    this.bindings();
    this.active_styles();
    return this;
  };

  ToggleSide.prototype.activate = function() {
    this.container.addClass(`active`);
  };

  ToggleSide.prototype.deactivate = function() {
    this.container.removeClass(`active`);
  };

  ToggleSide.prototype.is_active = function() {
    return this.container.hasClass(`active`);
  };

  ToggleSide.prototype.bindings = function() {
    var ts = this;
    this.container.click(function() {
      if (!ts.is_active()) {
        ts.activate();
        ts.container.trigger(`activate`, [ts]);
      }
    });
  };

  ToggleSide.prototype.disable = function() {
    this.container.addClass(`disabled`);
    this.container.off(`click`);
  };

  ToggleSide.prototype.enable = function() {
    this.container.removeClass(`disabled`);
    this.bindings();
  };

  ToggleSide.prototype.active_styles = function() {
    this.container.css({'min-width': this.config.min_side_width});
  };

  var Toggle = function(div, values) {
    this.class_name = `toggle_container`;
    this.config = {
      min_side_width: `30px`,
    };
  };
  _.inherit(Toggle, JSWidgetList);

  Toggle.prototype.create = function(div, values, config) {
    this.config = _.extend(this.config, config);
    Toggle.superclass.create.call(this, div);

    this.toggle = $(`<div>`).addClass(`toggle`);
    this.appendTo = this.toggle;

    _.each(values, function(v) {
      this.append(new ToggleSide().create(null, v, this.config));
    }, this);

    this.value = null;
    // Set a default value
    if (`selected` in this.config) {
      this.set_selected(this.config.selected);
    }
    this.container.html(this.toggle);

    this.bindings();
    return this;
  };

  Toggle.prototype.set_selected = function(val) {
    _.each(this.widgets, function(w) {
      if (w.value === val) {
        w.activate();
        this.value = w.value;
        this.container.attr(`val`, this.value);
      } else {
        w.deactivate();
      }
    }, this);
  };

  Toggle.prototype.bindings = function() {
    var t = this;
    this.container.bind(`activate`, function(ev, toggle_side) {
      ev.stopPropagation();
      _.each(t.widgets, function(w) {
        if (w !== toggle_side) {
          w.deactivate();
        }
      });
      t.value = toggle_side.value;
      t.container.attr(`val`, t.value);
      t.container.trigger(`change`, [t]);
    });
  };

  Toggle.prototype.disable = function() {
    _.each(this.widgets, function(ts) {
      ts.disable();
    });
  };

  Toggle.prototype.enable = function() {
    _.each(this.widgets, function(ts) {
      ts.enable();
    });
  };

  return {
    Toggle,
    ToggleSide,
  };
});

}.call(window));